export const USER_FIELD_GROUP_OPTIONS = [
  { value: 'General', label: 'General' },
  { value: 'Dirección', label: 'Dirección' },
] as const;

export type UserFieldGroupValue = (typeof USER_FIELD_GROUP_OPTIONS)[number]['value'];

const USER_FIELD_GROUP_VALUES = new Set<string>(
  USER_FIELD_GROUP_OPTIONS.map((o) => o.value),
);

/** Normaliza el valor de grupo guardado*/
export function normalizeUserFieldGroupValue(
  value: string | null | undefined,
): UserFieldGroupValue | null {
  if (value != null && USER_FIELD_GROUP_VALUES.has(String(value))) {
    return value as UserFieldGroupValue;
  }
  return null;
}
